export default "/fonts/vendor/mdui/dist/roboto/Roboto-RegularItalic.woff?33d48155cd9f38c64e71b9d016dd61fb";